













































import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { DocumentFile } from '@/types/document'
import FileInput from '@/components/common/inputs/FileInput.vue'
import dayjs from 'dayjs'

@Component({
  components: {
    FileInput,
    Loading: () => import('@/components/common/loadings/UploadLoading.vue')
  },
  filters: {
    formatDate(dateString: string) {
      return dayjs(dateString).format('YYYY/MM/DD H:ss')
    }
  }
})
export default class DocumentEdit extends Vue {
  $store!: ExStore
  document: DocumentFile | null = null
  base64 = ''
  fileSelect = false
  loading = false

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get patientId() {
    return this.userInfo.id
  }

  get documentId() {
    return Number(this.$route.params.documentId)
  }

  get senderName() {
    const file = this.document
    if (file?.worker) {
      return `${file.worker.lastName}${file.worker.occupation.name}`
    }
    return `${this.userInfo.lastName}${this.userInfo.firstName}`
  }

  async fetchDocument() {
    try {
      const res = await this.$api.document.fetchOne({
        patientId: this.patientId,
        documentId: this.documentId
      })
      this.document = res
      this.document.fileName = this.document.fileName || ''
      this.document.title = this.document.title || ''
    } catch (e) {
      if (e.message === 'Not Found') {
        this.$router.replace({ name: 'PatientDocumentList' })
      }
    }
  }

  async upload() {
    this.loading = true
    try {
      await this.$api.document.patch({
        patientId: this.patientId,
        documentId: this.documentId,
        payload: {
          title: this.document?.title,
          fileName: this.document?.fileName
          // fileContent: this.base64
        }
      })
      this.$router.push({
        name: 'PatientDocumentList'
      })
    } catch (e) {
      console.error(e)
      this.loading = false
    }
  }

  async created() {
    await this.fetchDocument()
  }
}
